<template>
  <div id="app-user-active-body" v-loading="loaded">
    <div id="app-user-active-title">
      <h1 id="app-user-active-title-h">资产信息</h1>
      <el-button id="app-user-active-title-button" type="primary" v-on:click="openUseActivationCodeDig">使用兑换码
      </el-button>
    </div>
    <div id="app-user-active-content-body" v-if="propertyList.length !== 0">
      <ul>
        <li class="app-user-active-list-li" v-for="item in propertyList" :key="item.id">
          <el-card class="app-user-active-card">
            <div class="app-user-active-card-title">资产类型:{{item.propertyTypeName}}</div>
            <div class="app-user-active-card-code" v-on:click="onCopy(item.propertyCode)"
                 @mouseenter="showCode(item)" @mouseout="hiddenCode(item)">
              <div v-if="item.effectiveStatus">{{ item.propertyCode }}</div>
              <div v-else>{{ initCode(item.propertyCode) }}</div>
            </div>
            <div class="app-user-active-card-time">记录时间:2020-06-30 00:00:00</div>
          </el-card>
        </li>
      </ul>
      <div style="clear:both;"></div>
    </div>
    <div id="app-user-active-content-body-empty" v-else>目前还没有资产哦,
      <a href="https://shop143025316.taobao.com" target="_blank" rel="noopener noreferrer">去辣椒淘宝店转转</a>
    </div>
    <UseActivationCode ref="UseActivationCode"></UseActivationCode>
  </div>
</template>

<script>

import {Message} from "element-ui";
import AxiosBase from "@/components/axiosBase";
import UseActivationCode from "@/views/user/center/myProperty/UseActivationCode";

export default {
  name: "MyProperty",
  components: {
    UseActivationCode
  },
  data() {
    return {
      loaded: true,
      propertyList: [],
    }
  },
  beforeCreate() {
    this.loaded = true;
    AxiosBase.axiosGet("/property/get-property", {}).then(response => {
      if (response !== 0) {
        this.propertyList = response.data;
        this.loaded = false;
      }
    })
  },
  methods: {
    getProperty() {
      AxiosBase.axiosGet("/property/get-property", {}).then(response => {
        if (response !== 0) {
          this.propertyList = response.data;
        }
      })
    },
    initCode(code) {
      return code.replace(/(.{9}).*(.{0})/, "$1****-****-****-************");
    },
    hiddenCode(item) {
      item.effectiveStatus = false;
    },
    showCode(item) {
      item.effectiveStatus = true;
    },
    onCopy(code) {
      this.$copyText(code).then(function () {
        Message({
          showClose: true,
          message: '成功复制密钥到剪切板',
          type: 'success'
        });
      })
    },
    openUseActivationCodeDig() {
      this.$refs.UseActivationCode.dialogFormVisible = true;
    }
  }
}
</script>

<style scoped>

#app-user-active-body {
  padding: 25px;
  /*border: 1px solid #000000;*/
  overflow-y: auto;
}

#app-user-active-title {
  position: relative;
  padding-bottom: 25px;
  border-bottom: 1px solid rgba(20, 20, 20, 0.2);
}

#app-user-active-title-h {
  font-size: 16px;
}

#app-user-active-title-button {
  position: absolute;
  top: 10px;
  right: 0;
  padding: 7px;
  border: 0;
  background: #ff8a00;
}

#app-user-active-content-body {
  margin-top: 25px;
  max-height: 725px;
  overflow-y: auto;
}

.app-user-active-list-li {
  float: left;
}

.app-user-active-card {
  width: 250px;
  height: 150px;
  margin-left: 10px;
  margin-bottom: 25px;
  padding: 10px;
  cursor: pointer;
}

.app-user-active-card:hover {
  transition: all 350ms ease-out;
  background: #FF8A00;
}

.app-user-active-card-title {
  width: 100%;
  height: 20px;
}

.app-user-active-card-code {
  width: 100%;
  height: 110px;
  line-height: 110px;
  text-align: center;
  font-size: 10px;

}

.app-user-active-card-time {
  width: 100%;
  height: 20px;
  line-height: 20px;
  text-align: right;
  font-size: 7px;
}

#app-user-active-content-body-empty {
  font-size: 20px;
  text-align: center;
  vertical-align: middle;
  margin-top: 250px;
}

#app-user-active-content-body-empty a {
  color: #ff8a00;
}

</style>